import { UseQueryOptions } from '@tanstack/react-query'
import { APIList } from 'src/interfaces'
import { UserRoles } from 'src/enums'
import { User } from 'src/api'
import { useUserListRequest } from './useUserList'
import { useUserRoleListRequest } from './useUserRoleList'

interface RequestParams {
  options?: Omit<
    UseQueryOptions<unknown, Error, APIList<User>>,
    'queryKey' | 'queryFn'
  >;
}

export const useAdminUserListRequest = ({ options }: RequestParams = {}) => {
  const { data: userRolesData } = useUserRoleListRequest({ params: { limit: 9999 } })
  const adminRoleIds = (userRolesData?.rows || [])
    .filter((role) => role.name === UserRoles.Admin)
    .map(({ id }) => id)

  return useUserListRequest({
    params: { limit: 9999, offset: 0, roleIds: adminRoleIds },
    options: {
      ...options,
      enabled: adminRoleIds.length > 0 && (options?.enabled ?? true),
    },
  })
}
